import React from "react"

import { Link } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./nav.module.scss"
import Submenu from "../submenu"

const Nav = ({ nav, type }) => {
  const navItem = (item) => {
    if (item.type === "url")
      return (
        <Link
          className={`${styles[`${type}Link`]} ${
            item.showMobile ? styles.showMobile : ""
          }`}
          activeClassName={styles[`${type}Link__active`]}
          key={item.title}
          to={item.url}
        >
          {item.title}
        </Link>
      )
    if (item.type === "email")
      return (
        <a
          className={styles[`${type}Link`]}
          href={`mailto:${item.email_address}?subject=${encodeURIComponent(
            item.email_subject
          )}&body=${encodeURIComponent(item.email_body)}`}
        >
          {item.title}
        </a>
      )
    if (item.type === "submenu")
      return (
        <button type="button" className={styles[`${type}Link`]}>
          {item.title}
        </button>
      )
    return null
  }

  return (
    <ul className={styles[`${type}Nav`]}>
      {nav.map((item) => (
        <li className={styles[`${type}Item`]} key={item.title}>
          {navItem(item)}
          {item.type === "submenu" ? (
            <Submenu menu={item.submenu.items} hamburger />
          ) : (
            ""
          )}
        </li>
      ))}
    </ul>
  )
}

export default Nav

Nav.propTypes = {
  nav: PropTypes.array.isRequired,
  type: PropTypes.array,
}

Nav.defaultProps = {
  type: "main",
}
